import { render, staticRenderFns } from "./BtnExcluirDespesaSebrae.vue?vue&type=template&id=3547e2a0"
import script from "./BtnExcluirDespesaSebrae.vue?vue&type=script&lang=js"
export * from "./BtnExcluirDespesaSebrae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports